module.exports = __webpack_public_path__ + "assets/8e3c7f5520f5ae906c6cf6d7f3ddcd19.eot";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/icons.eot
// module id = 1510
// module chunks = 0